import React, { useState } from 'react';
import {
    Shield, Twitter, Linkedin, Github, Mail, ChevronRight,User,
    BookOpen, Video, FileText, Calendar, Download, HeadphonesIcon,
    FileText as TermsIcon, ShieldCheck, Cookie, MapPin, X,Phone,Check,Headset,
    AlertTriangle, Info, Server, UserCheck, BarChart2, MessageSquare,Clock,
    Lock, Users, Gavel, RefreshCw, Eye, Edit, Trash2, Settings,  Send,
  } from 'lucide-react';

const Footer = ({
  showTermsModal, 
  setShowTermsModal,
  showPrivacyModal, 
  setShowPrivacyModal,
  showCookiesModal, 
  setShowCookiesModal, 
  showSupportModal, 
  setShowSupportModal 
}) => {
  return (
    <footer className="bg-gradient-to-b from-slate-950 to-black border-t border-slate-800/50 py-8 mt-12">
      <div className="max-w-7xl mx-auto px-6">
        {/* Main Footer Content */}
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8">
          {/* Brand Column */}
          <div className="space-y-4">
            <div className="flex items-center space-x-2">
              <Shield className="w-6 h-6 text-blue-500" />
              <h3 className="text-xl font-bold bg-clip-text text-transparent bg-gradient-to-r from-blue-400 to-indigo-400">
                TRACE MASTER
              </h3>
            </div>
            <p className="text-sm text-slate-400 leading-relaxed">
              Professional digital forensics platform with advanced trace analysis capabilities for cybersecurity professionals and investigators.
            </p>
            <div className="pt-2 flex items-center space-x-4">
              <a href="#" className="text-slate-400 hover:text-blue-400 transition-colors">
                <Twitter className="w-5 h-5" />
              </a>
              <a href="#" className="text-slate-400 hover:text-blue-400 transition-colors">
                <Linkedin className="w-5 h-5" />
              </a>
              <a href="#" className="text-slate-400 hover:text-blue-400 transition-colors">
                <Github className="w-5 h-5" />
              </a>
              <a href="#" className="text-slate-400 hover:text-blue-400 transition-colors">
                <Mail className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Navigation Column */}
          <div className="space-y-4">
            <h4 className="text-white font-medium text-lg">Navigation</h4>
            <ul className="space-y-2">
              {['Dashboard', 'Trace Analysis', 'Reports', 'Documentation', 'API Access'].map((item) => (
                <li key={item}>
                  <a href="#" className="text-sm text-slate-400 hover:text-blue-400 transition-colors flex items-center">
                    <ChevronRight className="w-4 h-4 mr-2 text-slate-600" />
                    {item}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Resources Column */}
          <div className="space-y-4">
            <h4 className="text-white font-medium text-lg">Resources</h4>
            <ul className="space-y-2">
              {[
                { name: 'Knowledge Base', Icon: BookOpen },
                { name: 'Video Tutorials', Icon: Video },
                { name: 'Case Studies', Icon: FileText },
                { name: 'Webinars', Icon: Calendar },
                { name: 'Downloads', Icon: Download },
              ].map(({ name, Icon }) => (
                <li key={name}>
                  <a href="#" className="text-sm text-slate-400 hover:text-blue-400 transition-colors flex items-center">
                    <Icon className="w-4 h-4 mr-2 text-slate-600" />
                    {name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact & Newsletter Column */}
          <div className="space-y-4">
            <h4 className="text-white font-medium text-lg">Stay Updated</h4>
            <p className="text-sm text-slate-400">Subscribe to our newsletter for product updates, security advisories, and industry insights.</p>
            <div className="flex items-stretch mt-2">
              <input 
                type="email" 
                placeholder="Your email address" 
                className="bg-slate-800/50 border border-slate-700 rounded-l-lg px-3 py-2 text-sm flex-grow focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500 text-white"
              />
              <button className="bg-blue-600 hover:bg-blue-700 text-white rounded-r-lg px-3 text-sm font-medium transition-colors">
                Subscribe
              </button>
            </div>
            <div className="pt-4">
              <button 
                onClick={() => setShowSupportModal(true)}
                className="w-full bg-blue-900/30 hover:bg-blue-900/50 text-blue-400 border border-blue-800/30 py-2.5 px-4 rounded-lg flex items-center justify-center space-x-2 transition-colors duration-200"
              >
                <HeadphonesIcon className="w-4 h-4" />
                <span className="text-sm font-medium">Contact Support</span>
              </button>
            </div>
          </div>
        </div>

        {/* Bottom Footer with Legal Links */}
        <div className="pt-6 border-t border-slate-800/50">
          <div className="flex flex-col md:flex-row md:items-center justify-between">
            <div className="text-xs text-slate-500 mb-4 md:mb-0">
              © {new Date().getFullYear()} TRACE MASTER • Developed by F/N Nuru The_Geek • All rights reserved
            </div>
            <div className="flex flex-wrap items-center gap-2">
              {/* Terms, Privacy, Cookies and Sitemap Buttons */}
              <button 
                onClick={() => setShowTermsModal(true)}
                className="text-xs bg-slate-800/50 hover:bg-slate-700 text-slate-300 px-3 py-1.5 rounded-lg flex items-center transition-colors duration-200"
              >
                <FileText className="w-3 h-3 mr-1.5" />
                Terms
              </button>
              <button 
                onClick={() => setShowPrivacyModal(true)}
                className="text-xs bg-slate-800/50 hover:bg-slate-700 text-slate-300 px-3 py-1.5 rounded-lg flex items-center transition-colors duration-200"
              >
                <ShieldCheck className="w-3 h-3 mr-1.5" />
                Privacy
              </button>
              <button 
                onClick={() => setShowCookiesModal(true)}
                className="text-xs bg-slate-800/50 hover:bg-slate-700 text-slate-300 px-3 py-1.5 rounded-lg flex items-center transition-colors duration-200"
              >
                <Cookie className="w-3 h-3 mr-1.5" />
                Cookies
              </button>
              <a
                href="#"
                className="text-xs bg-slate-800/50 hover:bg-slate-700 text-slate-300 px-3 py-1.5 rounded-lg flex items-center transition-colors duration-200"
              >
                <MapPin className="w-3 h-3 mr-1.5" />
                Sitemap
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Enhanced Modals for Terms, Privacy, and Cookies */}
      {showTermsModal && (
        <TermsModal onClose={() => setShowTermsModal(false)} />
      )}
      {showPrivacyModal && (
        <PrivacyModal onClose={() => setShowPrivacyModal(false)} />
      )}
      {showCookiesModal && (
        <CookiesModal onClose={() => setShowCookiesModal(false)} />
      )}
        {showSupportModal && (
        <SupportModal onClose={() => setShowSupportModal(false)} />
      )}
    </footer>
  );
};

const TermsModal = ({ onClose }) => (
  <Modal onClose={onClose}>
     <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/80 backdrop-blur-sm">
    <div className="relative bg-gradient-to-b from-slate-900 to-slate-950 border border-slate-800 rounded-xl max-w-4xl w-full mx-4 shadow-2xl overflow-hidden">
      <div className="bg-gradient-to-r from-blue-900/30 via-indigo-900/20 to-transparent border-b border-blue-900/30 p-5">
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-3">
            <div className="bg-blue-500/20 p-1.5 rounded-lg">
              <FileText className="w-6 h-6 text-blue-400" />
            </div>
            <h3 className="text-xl font-bold text-white">Terms and Conditions</h3>
          </div>
          <button 
            onClick={onClose}
            className="p-1.5 rounded-lg hover:bg-slate-800/50 transition-colors"
          >
            <X className="w-5 h-5 text-slate-400" />
          </button>
        </div>
      </div>
      <div className="p-6 max-h-[70vh] overflow-y-auto custom-scrollbar">
        <div className="prose prose-invert prose-headings:text-white prose-headings:font-medium prose-p:text-slate-300 max-w-none">
          <div className="flex items-center justify-between">
            <h4 className="text-white font-medium mb-0">Last Updated: {new Date().toLocaleDateString()}</h4>
            <span className="text-xs px-2 py-1 bg-blue-500/10 text-blue-400 rounded-md">Version 2.3</span>
          </div>
          
          <p className="text-slate-300 mt-4">
            By accessing and using TraceMaster (the "Service"), you agree to be bound by these Terms and Conditions (the "Terms"). Please read them carefully before using the Service.
          </p>
          
          <div className="space-y-6 mt-6">
            <div>
              <h5 className="flex items-center space-x-2">
                <span className="inline-block w-7 h-7 rounded-full bg-gradient-to-br from-blue-500 to-indigo-600 flex items-center justify-center text-white text-sm font-bold">1</span>
                <span>License and Access</span>
              </h5>
              <div className="ml-9">
                <p className="text-slate-400 text-sm">
                  TraceMaster grants you a limited, non-exclusive, non-transferable, and revocable license to access and use the Service solely in accordance with these Terms.
                </p>
                <p className="text-slate-400 text-sm">
                  To access certain features of the Service, you may be required to register for an account. You are responsible for maintaining the confidentiality of your account credentials and for all activities that occur under your account.
                </p>
              </div>
            </div>
            
            <div>
              <h5 className="flex items-center space-x-2">
                <span className="inline-block w-7 h-7 rounded-full bg-gradient-to-br from-blue-500 to-indigo-600 flex items-center justify-center text-white text-sm font-bold">2</span>
                <span>Usage Restrictions</span>
              </h5>
              <div className="ml-9">
                <p className="text-slate-400 text-sm">
                  You may not reverse engineer, decompile, disassemble, or attempt to derive the source code of any part of the Service.
                </p>
                <p className="text-slate-400 text-sm">
                  You may not use the Service for any illegal purpose or to conduct any activity that violates the rights of others or that may be harmful to others.
                </p>
                <div className="mt-3 bg-red-900/20 border border-red-800/30 rounded-lg p-3">
                  <p className="text-red-300 text-sm flex items-start">
                    <AlertTriangle className="w-4 h-4 mr-2 mt-0.5 text-red-400 flex-shrink-0" />
                    <span>All forensic activities must comply with applicable local, state, federal, and international laws. TraceMaster is intended for legitimate security and investigative purposes only.</span>
                  </p>
                </div>
              </div>
            </div>
            
            <div>
              <h5 className="flex items-center space-x-2">
                <span className="inline-block w-7 h-7 rounded-full bg-gradient-to-br from-blue-500 to-indigo-600 flex items-center justify-center text-white text-sm font-bold">3</span>
                <span>Data Accuracy and Disclaimer</span>
              </h5>
              <div className="ml-9">
                <p className="text-slate-400 text-sm">
                  TraceMaster provides information "as is" without warranty of any kind, either express or implied, including, but not limited to, the implied warranties of merchantability, fitness for a particular purpose, or non-infringement.
                </p>
                <p className="text-slate-400 text-sm">
                  The Service relies on various data sources and analysis techniques to provide results. While we strive for accuracy, we cannot guarantee the completeness, timeliness, or accuracy of the information provided.
                </p>
                <p className="text-slate-400 text-sm">
                  You acknowledge that any reliance on the information provided by the Service is at your own risk. Results should be verified through official channels and procedures before taking any legal or investigative action.
                </p>
              </div>
            </div>
            
            <div>
              <h5 className="flex items-center space-x-2">
                <span className="inline-block w-7 h-7 rounded-full bg-gradient-to-br from-blue-500 to-indigo-600 flex items-center justify-center text-white text-sm font-bold">4</span>
                <span>Intellectual Property</span>
              </h5>
              <div className="ml-9">
                <p className="text-slate-400 text-sm">
                  The Service and its original content, features, and functionality are owned by TraceMaster and are protected by international copyright, trademark, patent, trade secret, and other intellectual property or proprietary rights laws.
                </p>
              </div>
            </div>
            
            <div>
              <h5 className="flex items-center space-x-2">
                <span className="inline-block w-7 h-7 rounded-full bg-gradient-to-br from-blue-500 to-indigo-600 flex items-center justify-center text-white text-sm font-bold">5</span>
                <span>Termination</span>
              </h5>
              <div className="ml-9">
                <p className="text-slate-400 text-sm">
                  We may terminate or suspend your access to the Service immediately, without prior notice or liability, for any reason whatsoever, including, without limitation, if you breach the Terms.
                </p>
                <p className="text-slate-400 text-sm">
                  Upon termination, your right to use the Service will immediately cease.
                </p>
              </div>
            </div>
            
            <div className="bg-blue-900/20 p-4 rounded-lg border border-blue-800/30">
              <h5 className="text-white font-medium">Legal Compliance</h5>
              <p className="text-slate-400 text-sm">
                Users are solely responsible for ensuring their use of TraceMaster complies with all applicable laws in their jurisdiction. The Service is designed for use by authorized professionals in accordance with relevant legal frameworks.
              </p>
              <p className="text-slate-400 text-sm mt-2">
                By using TraceMaster, you represent and warrant that you have the legal authority to conduct the forensic activities you undertake with our Service.
              </p>
            </div>
            
            <div>
              <h5 className="flex items-center space-x-2">
                <span className="inline-block w-7 h-7 rounded-full bg-gradient-to-br from-blue-500 to-indigo-600 flex items-center justify-center text-white text-sm font-bold">6</span>
                <span>Changes to Terms</span>
              </h5>
              <div className="ml-9">
                <p className="text-slate-400 text-sm">
                  We reserve the right, at our sole discretion, to modify or replace these Terms at any time. If a revision is material, we will provide at least 30 days' notice prior to any new terms taking effect. What constitutes a material change will be determined at our sole discretion.
                </p>
                <p className="text-slate-400 text-sm">
                  By continuing to access or use our Service after those revisions become effective, you agree to be bound by the revised terms.
                </p>
              </div>
            </div>
            
            <div>
              <h5 className="flex items-center space-x-2">
                <span className="inline-block w-7 h-7 rounded-full bg-gradient-to-br from-blue-500 to-indigo-600 flex items-center justify-center text-white text-sm font-bold">7</span>
                <span>Governing Law</span>
              </h5>
              <div className="ml-9">
                <p className="text-slate-400 text-sm">
                  These Terms shall be governed and construed in accordance with the laws applicable in your jurisdiction, without regard to its conflict of law provisions.
                </p>
                <p className="text-slate-400 text-sm">
                  Our failure to enforce any right or provision of these Terms will not be considered a waiver of those rights.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="bg-slate-900/80 border-t border-slate-800 px-6 py-4 flex justify-between items-center">
        <a href="#" className="text-sm text-blue-400 hover:text-blue-300 transition-colors">
          <Download className="w-4 h-4 inline-block mr-1.5" />
          Download PDF
        </a>
        <div className="flex space-x-3">
          <button
            onClick={onClose}
            className="px-3 py-2 bg-slate-800 hover:bg-slate-700 text-slate-300 rounded-lg text-sm transition-colors duration-200"
          >
            Decline
          </button>
          <button
            onClick={onClose}
            className="px-4 py-2 bg-gradient-to-r from-blue-600 to-indigo-600 hover:from-blue-700 hover:to-indigo-700 text-white rounded-lg font-medium transition-all duration-200 shadow-lg shadow-blue-900/30"
          >
            I Accept
          </button>
        </div>
      </div>
    </div>
  </div>
  </Modal>
);

const PrivacyModal = ({ onClose }) => (
  <Modal onClose={onClose}>
      <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/80 backdrop-blur-sm">
    <div className="relative bg-gradient-to-b from-slate-900 to-slate-950 border border-slate-800 rounded-xl max-w-4xl w-full mx-4 shadow-2xl overflow-hidden">
      <div className="bg-gradient-to-r from-blue-900/30 via-indigo-900/20 to-transparent border-b border-blue-900/30 p-5">
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-3">
            <div className="bg-green-500/20 p-1.5 rounded-lg">
              <ShieldCheck className="w-6 h-6 text-green-400" />
            </div>
            <h3 className="text-xl font-bold text-white">Privacy Policy</h3>
          </div>
          <button 
            onClick={onClose}
            className="p-1.5 rounded-lg hover:bg-slate-800/50 transition-colors"
          >
            <X className="w-5 h-5 text-slate-400" />
          </button>
        </div>
      </div>
      <div className="p-6 max-h-[70vh] overflow-y-auto custom-scrollbar">
        <div className="prose prose-invert prose-headings:text-white prose-headings:font-medium prose-p:text-slate-300 max-w-none">
          <div className="flex items-center justify-between">
            <h4 className="text-white font-medium mb-0">Effective Date: {new Date().toLocaleDateString()}</h4>
            <span className="text-xs px-2 py-1 bg-green-500/10 text-green-400 rounded-md">Version 3.1</span>
          </div>
          
          <p className="text-slate-300 mt-4">
            This Privacy Policy describes how TraceMaster ("we", "our", or "us") collects, uses, and discloses your information when you use our service (the "Service").
          </p>
          
          <div className="space-y-6 mt-6">
            <div>
              <h5 className="flex items-center space-x-2">
                <span className="inline-block w-7 h-7 rounded-full bg-gradient-to-br from-green-500 to-emerald-600 flex items-center justify-center text-white text-sm font-bold">1</span>
                <span>Information We Collect</span>
              </h5>
              <div className="ml-9">
                <p className="text-slate-400 text-sm">
                  We collect several types of information from and about users of our Service, including:
                </p>
                
                <ul className="mt-2 space-y-2 text-slate-400 text-sm">
                  <li className="flex items-start">
                    <Check className="w-4 h-4 text-green-500 mr-2 mt-0.5 flex-shrink-0" />
                    <span><strong className="text-white">Account Information:</strong> When you register for an account, we collect your name, email address, and password.</span>
                  </li>
                  <li className="flex items-start">
                    <Check className="w-4 h-4 text-green-500 mr-2 mt-0.5 flex-shrink-0" />
                    <span><strong className="text-white">Usage Data:</strong> We collect information about how you interact with our Service, including search queries, features used, and analysis results.</span>
                  </li>
                  <li className="flex items-start">
                    <Check className="w-4 h-4 text-green-500 mr-2 mt-0.5 flex-shrink-0" />
                    <span><strong className="text-white">Technical Data:</strong> We collect information about your device and internet connection, including your IP address, browser type, operating system, and device identifiers.</span>
                  </li>
                  <li className="flex items-start">
                    <Check className="w-4 h-4 text-green-500 mr-2 mt-0.5 flex-shrink-0" />
                    <span><strong className="text-white">Cookies:</strong> We use cookies and similar tracking technologies to collect information about your browsing activities and preferences.</span>
                  </li>
                </ul>
                
                <div className="mt-3 bg-green-900/20 border border-green-800/30 rounded-lg p-3">
                  <p className="text-green-300 text-sm flex items-start">
                    <Info className="w-4 h-4 mr-2 mt-0.5 text-green-400 flex-shrink-0" />
                    <span>Search queries and analysis results are stored temporarily during your active session and are automatically deleted within 24 hours after your session ends, unless you explicitly save them to your account.</span>
                  </p>
                </div>
              </div>
            </div>
            
            <div>
              <h5 className="flex items-center space-x-2">
                <span className="inline-block w-7 h-7 rounded-full bg-gradient-to-br from-green-500 to-emerald-600 flex items-center justify-center text-white text-sm font-bold">2</span>
                <span>How We Use Your Information</span>
              </h5>
              <div className="ml-9">
                <p className="text-slate-400 text-sm">
                  We use the information we collect for various purposes, including:
                </p>
                
                <div className="mt-3 grid grid-cols-1 md:grid-cols-2 gap-3">
                  <div className="bg-slate-800/50 p-3 rounded-lg border border-slate-700">
                    <h6 className="text-white font-medium mb-1.5 flex items-center">
                      <Server className="w-4 h-4 mr-2 text-green-400" />
                      Providing the Service
                    </h6>
                    <p className="text-slate-400 text-xs">To operate, maintain, and improve our Service, including processing search queries and generating analysis results.</p>
                  </div>
                  
                  <div className="bg-slate-800/50 p-3 rounded-lg border border-slate-700">
                    <h6 className="text-white font-medium mb-1.5 flex items-center">
                      <UserCheck className="w-4 h-4 mr-2 text-green-400" />
                      Account Management
                    </h6>
                    <p className="text-slate-400 text-xs">To manage your account, provide customer support, and ensure security of your account.</p>
                  </div>
                  
                  <div className="bg-slate-800/50 p-3 rounded-lg border border-slate-700">
                    <h6 className="text-white font-medium mb-1.5 flex items-center">
                      <BarChart2 className="w-4 h-4 mr-2 text-green-400" />
                      Analytics
                    </h6>
                    <p className="text-slate-400 text-xs">To analyze usage patterns and improve our Service based on how users interact with it.</p>
                  </div>
                  
                  <div className="bg-slate-800/50 p-3 rounded-lg border border-slate-700">
                    <h6 className="text-white font-medium mb-1.5 flex items-center">
                      <MessageSquare className="w-4 h-4 mr-2 text-green-400" />
                      Communication
                    </h6>
                    <p className="text-slate-400 text-xs">To send updates, security alerts, and support messages related to our Service.</p>
                  </div>
                </div>
              </div>
            </div>
            
            <div>
              <h5 className="flex items-center space-x-2">
                <span className="inline-block w-7 h-7 rounded-full bg-gradient-to-br from-green-500 to-emerald-600 flex items-center justify-center text-white text-sm font-bold">3</span>
                <span>Data Security</span>
              </h5>
              <div className="ml-9">
                <p className="text-slate-400 text-sm">
                  We take data security seriously and implement appropriate technical and organizational measures to protect your information:
                </p>
                
                <ul className="mt-2 space-y-2 text-slate-400 text-sm">
                  <li className="flex items-start">
                    <Lock className="w-4 h-4 text-green-500 mr-2 mt-0.5 flex-shrink-0" />
                    <span>All data transmissions are encrypted using TLS 1.3 protocol.</span>
                  </li>
                  <li className="flex items-start">
                    <Lock className="w-4 h-4 text-green-500 mr-2 mt-0.5 flex-shrink-0" />
                    <span>Stored data is encrypted at rest using AES-256 encryption.</span>
                  </li>
                  <li className="flex items-start">
                    <Lock className="w-4 h-4 text-green-500 mr-2 mt-0.5 flex-shrink-0" />
                    <span>Access to your data is restricted to authorized personnel only.</span>
                  </li>
                  <li className="flex items-start">
                    <Lock className="w-4 h-4 text-green-500 mr-2 mt-0.5 flex-shrink-0" />
                    <span>Regular security audits and penetration testing to ensure system integrity.</span>
                  </li>
                </ul>
                
                <div className="mt-3 bg-yellow-900/20 border border-yellow-800/30 rounded-lg p-3">
                  <p className="text-yellow-300 text-sm flex items-start">
                    <AlertTriangle className="w-4 h-4 mr-2 mt-0.5 text-yellow-400 flex-shrink-0" />
                    <span>Despite our best efforts, no method of transmission over the Internet or electronic storage is 100% secure. While we strive to use commercially acceptable means to protect your information, we cannot guarantee its absolute security.</span>
                  </p>
                </div>
              </div>
            </div>
            
            <div>
            <h5 className="flex items-center space-x-2">
                <span className="inline-block w-7 h-7 rounded-full bg-gradient-to-br from-green-500 to-emerald-600 flex items-center justify-center text-white text-sm font-bold">4</span>
                <span>Data Sharing and Disclosure</span>
              </h5>
              <div className="ml-9">
                <p className="text-slate-400 text-sm">
                  We may share your information in the following circumstances:
                </p>
                
                <div className="mt-3 grid grid-cols-1 md:grid-cols-2 gap-3">
                  <div className="bg-slate-800/50 p-3 rounded-lg border border-slate-700">
                    <h6 className="text-white font-medium mb-1.5 flex items-center">
                      <Users className="w-4 h-4 mr-2 text-green-400" />
                      Service Providers
                    </h6>
                    <p className="text-slate-400 text-xs">With trusted third parties who assist us in operating our Service, conducting our business, or serving our users.</p>
                  </div>
                  
                  <div className="bg-slate-800/50 p-3 rounded-lg border border-slate-700">
                    <h6 className="text-white font-medium mb-1.5 flex items-center">
                      <Gavel className="w-4 h-4 mr-2 text-green-400" />
                      Legal Requirements
                    </h6>
                    <p className="text-slate-400 text-xs">When required by law or to respond to valid legal process (e.g., subpoenas, court orders).</p>
                  </div>
                  
                  <div className="bg-slate-800/50 p-3 rounded-lg border border-slate-700">
                    <h6 className="text-white font-medium mb-1.5 flex items-center">
                      <Shield className="w-4 h-4 mr-2 text-green-400" />
                      Protection of Rights
                    </h6>
                    <p className="text-slate-400 text-xs">To protect the rights, property, or safety of TraceMaster, our users, or the public.</p>
                  </div>
                  
                  <div className="bg-slate-800/50 p-3 rounded-lg border border-slate-700">
                    <h6 className="text-white font-medium mb-1.5 flex items-center">
                      <RefreshCw className="w-4 h-4 mr-2 text-green-400" />
                      Business Transfers
                    </h6>
                    <p className="text-slate-400 text-xs">In connection with any merger, sale of company assets, or acquisition of all or part of our business.</p>
                  </div>
                </div>
                
                <div className="mt-3 bg-blue-900/20 border border-blue-800/30 rounded-lg p-3">
                  <p className="text-blue-300 text-sm flex items-start">
                    <Info className="w-4 h-4 mr-2 mt-0.5 text-blue-400 flex-shrink-0" />
                    <span>We do not sell or rent your personal information to third parties for their marketing purposes without your explicit consent.</span>
                  </p>
                </div>
              </div>
            </div>
            
            <div>
              <h5 className="flex items-center space-x-2">
                <span className="inline-block w-7 h-7 rounded-full bg-gradient-to-br from-green-500 to-emerald-600 flex items-center justify-center text-white text-sm font-bold">5</span>
                <span>Your Data Rights</span>
              </h5>
              <div className="ml-9">
                <p className="text-slate-400 text-sm">
                  Depending on your jurisdiction, you may have certain rights regarding your personal data:
                </p>
                
                <div className="mt-3 grid grid-cols-1 md:grid-cols-2 gap-3">
                  <div className="bg-slate-800/50 p-3 rounded-lg border border-slate-700">
                    <h6 className="text-white font-medium mb-1.5 flex items-center">
                      <Eye className="w-4 h-4 mr-2 text-green-400" />
                      Access
                    </h6>
                    <p className="text-slate-400 text-xs">Request a copy of the personal data we hold about you.</p>
                  </div>
                  
                  <div className="bg-slate-800/50 p-3 rounded-lg border border-slate-700">
                    <h6 className="text-white font-medium mb-1.5 flex items-center">
                      <Edit className="w-4 h-4 mr-2 text-green-400" />
                      Rectification
                    </h6>
                    <p className="text-slate-400 text-xs">Request correction of inaccurate or incomplete data.</p>
                  </div>
                  
                  <div className="bg-slate-800/50 p-3 rounded-lg border border-slate-700">
                    <h6 className="text-white font-medium mb-1.5 flex items-center">
                      <Trash2 className="w-4 h-4 mr-2 text-green-400" />
                      Erasure
                    </h6>
                    <p className="text-slate-400 text-xs">Request deletion of your personal data under certain conditions.</p>
                  </div>
                  
                  <div className="bg-slate-800/50 p-3 rounded-lg border border-slate-700">
                    <h6 className="text-white font-medium mb-1.5 flex items-center">
                      <Download className="w-4 h-4 mr-2 text-green-400" />
                      Portability
                    </h6>
                    <p className="text-slate-400 text-xs">Request transfer of your data to another service provider.</p>
                  </div>
                </div>
                
                <div className="mt-3 bg-purple-900/20 border border-purple-800/30 rounded-lg p-3">
                  <p className="text-purple-300 text-sm flex items-start">
                    <Info className="w-4 h-4 mr-2 mt-0.5 text-purple-400 flex-shrink-0" />
                    <span>To exercise these rights, please contact us at privacy@tracemaster.com. We may need to verify your identity before processing your request.</span>
                  </p>
                </div>
              </div>
            </div>
            
            <div>
              <h5 className="flex items-center space-x-2">
                <span className="inline-block w-7 h-7 rounded-full bg-gradient-to-br from-green-500 to-emerald-600 flex items-center justify-center text-white text-sm font-bold">6</span>
                <span>International Data Transfers</span>
              </h5>
              <div className="ml-9">
                <p className="text-slate-400 text-sm">
                  Your information may be transferred to and maintained on computers located outside of your state, province, country, or other governmental jurisdiction where the data protection laws may differ from those in your jurisdiction.
                </p>
                <p className="text-slate-400 text-sm">
                  We implement appropriate safeguards (such as Standard Contractual Clauses) when transferring data outside the European Economic Area (EEA) or other jurisdictions with strict data protection laws.
                </p>
              </div>
            </div>
            
            <div>
              <h5 className="flex items-center space-x-2">
                <span className="inline-block w-7 h-7 rounded-full bg-gradient-to-br from-green-500 to-emerald-600 flex items-center justify-center text-white text-sm font-bold">7</span>
                <span>Changes to This Policy</span>
              </h5>
              <div className="ml-9">
                <p className="text-slate-400 text-sm">
                  We may update our Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page and updating the "Effective Date" at the top.
                </p>
                <p className="text-slate-400 text-sm">
                  We will let you know via email and/or a prominent notice on our Service prior to the change becoming effective and update the "Effective Date" at the top of this Privacy Policy.
                </p>
              </div>
            </div>
            
            <div className="bg-slate-800/50 p-4 rounded-lg border border-slate-700">
              <h5 className="text-white font-medium">Contact Us</h5>
              <p className="text-slate-400 text-sm mt-2">
                If you have any questions about this Privacy Policy, please contact us:
              </p>
              <p className="text-slate-400 text-sm mt-1">
                <strong>Email:</strong> privacy@tracemaster.com
              </p>
              <p className="text-slate-400 text-sm">
                <strong>Mail:</strong> Data Protection Officer, TraceMaster Inc., 123 Security Way, Cyber City
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className="bg-slate-900/80 border-t border-slate-800 px-6 py-4 flex justify-end">
        <button
          onClick={onClose}
          className="px-4 py-2 bg-gradient-to-r from-green-600 to-emerald-600 hover:from-green-700 hover:to-emerald-700 text-white rounded-lg font-medium transition-all duration-200 shadow-lg shadow-green-900/30"
        >
          I Understand
        </button>
      </div>
    </div>
  </div>

  </Modal>
);

const CookiesModal = ({ onClose }) => (
    <Modal onClose={onClose}>
     <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/80 backdrop-blur-sm">
    <div className="relative bg-gradient-to-b from-slate-900 to-slate-950 border border-slate-800 rounded-xl max-w-4xl w-full mx-4 shadow-2xl overflow-hidden">
      <div className="bg-gradient-to-r from-blue-900/30 via-indigo-900/20 to-transparent border-b border-blue-900/30 p-5">
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-3">
            <div className="bg-yellow-500/20 p-1.5 rounded-lg">
              <Cookie className="w-6 h-6 text-yellow-400" />
            </div>
            <h3 className="text-xl font-bold text-white">Cookies Policy</h3>
          </div>
          <button 
             onClick={onClose}
            className="p-1.5 rounded-lg hover:bg-slate-800/50 transition-colors"
          >
            <X className="w-5 h-5 text-slate-400" />
          </button>
        </div>
      </div>
      <div className="p-6 max-h-[70vh] overflow-y-auto custom-scrollbar">
        <div className="prose prose-invert prose-headings:text-white prose-headings:font-medium prose-p:text-slate-300 max-w-none">
          <div className="flex items-center justify-between">
            <h4 className="text-white font-medium mb-0">Last Updated: {new Date().toLocaleDateString()}</h4>
            <span className="text-xs px-2 py-1 bg-yellow-500/10 text-yellow-400 rounded-md">Version 2.0</span>
          </div>
          
          <p className="text-slate-300 mt-4">
            This Cookies Policy explains how TraceMaster ("we", "our", or "us") uses cookies and similar tracking technologies when you use our service (the "Service").
          </p>
          
          <div className="space-y-6 mt-6">
            <div>
              <h5 className="flex items-center space-x-2">
                <span className="inline-block w-7 h-7 rounded-full bg-gradient-to-br from-yellow-500 to-amber-600 flex items-center justify-center text-white text-sm font-bold">1</span>
                <span>What Are Cookies?</span>
              </h5>
              <div className="ml-9">
                <p className="text-slate-400 text-sm">
                  Cookies are small text files that are stored on your device when you visit a website. They are widely used to make websites work more efficiently, as well as to provide information to the website owners.
                </p>
                <p className="text-slate-400 text-sm">
                  We use both session cookies (which expire when you close your browser) and persistent cookies (which stay on your device until they expire or you delete them).
                </p>
              </div>
            </div>
            
            <div>
              <h5 className="flex items-center space-x-2">
                <span className="inline-block w-7 h-7 rounded-full bg-gradient-to-br from-yellow-500 to-amber-600 flex items-center justify-center text-white text-sm font-bold">2</span>
                <span>How We Use Cookies</span>
              </h5>
              <div className="ml-9">
                <p className="text-slate-400 text-sm">
                  We use cookies for several purposes:
                </p>
                
                <div className="mt-3 grid grid-cols-1 md:grid-cols-2 gap-3">
                  <div className="bg-slate-800/50 p-3 rounded-lg border border-slate-700">
                    <h6 className="text-white font-medium mb-1.5 flex items-center">
                      <Settings className="w-4 h-4 mr-2 text-yellow-400" />
                      Essential Cookies
                    </h6>
                    <p className="text-slate-400 text-xs">Required for the Service to function properly (e.g., authentication, security).</p>
                  </div>
                  
                  <div className="bg-slate-800/50 p-3 rounded-lg border border-slate-700">
                    <h6 className="text-white font-medium mb-1.5 flex items-center">
                      <User className="w-4 h-4 mr-2 text-yellow-400" />
                      Preference Cookies
                    </h6>
                    <p className="text-slate-400 text-xs">Remember your choices (e.g., language, theme preferences).</p>
                  </div>
                  
                  <div className="bg-slate-800/50 p-3 rounded-lg border border-slate-700">
                    <h6 className="text-white font-medium mb-1.5 flex items-center">
                      <BarChart2 className="w-4 h-4 mr-2 text-yellow-400" />
                      Analytics Cookies
                    </h6>
                    <p className="text-slate-400 text-xs">Help us understand how visitors interact with our Service.</p>
                  </div>
                  
                  <div className="bg-slate-800/50 p-3 rounded-lg border border-slate-700">
                    <h6 className="text-white font-medium mb-1.5 flex items-center">
                      <Shield className="w-4 h-4 mr-2 text-yellow-400" />
                      Security Cookies
                    </h6>
                    <p className="text-slate-400 text-xs">Help detect malicious activity and protect user data.</p>
                  </div>
                </div>
              </div>
            </div>
            
            <div>
              <h5 className="flex items-center space-x-2">
                <span className="inline-block w-7 h-7 rounded-full bg-gradient-to-br from-yellow-500 to-amber-600 flex items-center justify-center text-white text-sm font-bold">3</span>
                <span>Third-Party Cookies</span>
              </h5>
              <div className="ml-9">
                <p className="text-slate-400 text-sm">
                  We may also use various third-party cookies to report usage statistics of the Service, deliver advertisements, and so on.
                </p>
                
                <div className="mt-3 space-y-3">
                    <div className="flex items-start space-x-3 p-3 bg-slate-800/50 rounded-lg border border-slate-700">
                        {/* Inline SVG for Google Icon */}
                        <svg
                        className="w-5 h-5 text-yellow-400 mt-0.5"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 48 48"
                        fill="currentColor"
                        >
                        <path d="M23.643 12.27H24.7l1.316 2.841h-25.266v4.68H8.540c-.007.08-.006.164-.006.248 0 3.049 2.755 4.976 6.447 4.976 2.657 0 5.697-.58 7.633-3.068l1.37 2c-2.673 2.048-5.673 3.007-8.783 3.007-7.171 0-12.783-4.754-12.783-11.762s5.612-11.76 12.783-11.76c7.648 0 12.15 4.426 12.15 11.172 0 .929-.098 1.536-.16 2.352z"/>
                        </svg>
                        <div>
                        <h6 className="text-white font-medium">Google Analytics</h6>
                        <p className="text-slate-400 text-xs">Helps us analyze how users interact with our Service.</p>
                        </div>
                    </div>
                
                  
                  <div className="flex items-start space-x-3 p-3 bg-slate-800/50 rounded-lg border border-slate-700">
                    <Shield className="w-5 h-5 text-yellow-400 mt-0.5" />
                    <div>
                      <h6 className="text-white font-medium">Security Services</h6>
                      <p className="text-slate-400 text-xs">Help protect our Service from malicious activity.</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            
            <div>
              <h5 className="flex items-center space-x-2">
                <span className="inline-block w-7 h-7 rounded-full bg-gradient-to-br from-yellow-500 to-amber-600 flex items-center justify-center text-white text-sm font-bold">4</span>
                <span>Managing Cookies</span>
              </h5>
              <div className="ml-9">
                <p className="text-slate-400 text-sm">
                  You can control and/or delete cookies as you wish:
                </p>
                
                <ul className="mt-2 space-y-2 text-slate-400 text-sm">
                  <li className="flex items-start">
                    <Check className="w-4 h-4 text-yellow-500 mr-2 mt-0.5 flex-shrink-0" />
                    <span>You can delete all cookies that are already on your computer.</span>
                  </li>
                  <li className="flex items-start">
                    <Check className="w-4 h-4 text-yellow-500 mr-2 mt-0.5 flex-shrink-0" />
                    <span>Most browsers allow you to refuse to accept cookies.</span>
                  </li>
                  <li className="flex items-start">
                    <Check className="w-4 h-4 text-yellow-500 mr-2 mt-0.5 flex-shrink-0" />
                    <span>You can use our cookie consent manager to control non-essential cookies.</span>
                  </li>
                </ul>
                
                <div className="mt-3 bg-yellow-900/20 border border-yellow-800/30 rounded-lg p-3">
                  <p className="text-yellow-300 text-sm flex items-start">
                    <AlertTriangle className="w-4 h-4 mr-2 mt-0.5 text-yellow-400 flex-shrink-0" />
                    <span>If you disable cookies, some features of our Service may not function properly.</span>
                  </p>
                </div>
              </div>
            </div>
            
            <div className="bg-slate-800/50 p-4 rounded-lg border border-slate-700">
              <h5 className="text-white font-medium">Contact Us</h5>
              <p className="text-slate-400 text-sm mt-2">
                If you have any questions about our use of cookies, please contact us at privacy@tracemaster.com.
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className="bg-slate-900/80 border-t border-slate-800 px-6 py-4 flex justify-between items-center">
        <button
         onClick={onClose}
          className="px-3 py-2 bg-slate-800 hover:bg-slate-700 text-slate-300 rounded-lg text-sm transition-colors duration-200"
        >
          Reject Non-Essential
        </button>
        <button
          onClick={onClose}
          className="px-4 py-2 bg-gradient-to-r from-yellow-600 to-amber-600 hover:from-yellow-700 hover:to-amber-700 text-white rounded-lg font-medium transition-all duration-200 shadow-lg shadow-yellow-900/30"
        >
          Accept All
        </button>
      </div>
    </div>
  </div>
  </Modal>
);

const SupportModal = ({ onClose }) => (
    <Modal onClose={onClose}>

  <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/80 backdrop-blur-sm">
    <div className="relative bg-gradient-to-b from-slate-900 to-slate-950 border border-slate-800 rounded-xl max-w-4xl w-full mx-4 shadow-2xl overflow-hidden">
      {/* Header with gradient */}
      <div className="bg-gradient-to-r from-blue-900/30 via-indigo-900/20 to-transparent border-b border-blue-900/30 p-5">
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-3">
            <div className="bg-blue-500/20 p-1.5 rounded-lg">
              <Headset className="w-6 h-6 text-blue-400" />
            </div>
            <h3 className="text-xl font-bold text-white">Contact TraceMaster Support</h3>
          </div>
          <button 
            onClick={onClose}
            className="p-1.5 rounded-lg hover:bg-slate-800/50 transition-colors"
          >
            <X className="w-5 h-5 text-slate-400" />
          </button>
        </div>
      </div>

      {/* Main Content */}
      <div className="p-6 max-h-[70vh] overflow-y-auto custom-scrollbar">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {/* Contact Form */}
          <div className="space-y-5">
            <h4 className="text-white font-medium text-lg flex items-center">
              <Send className="w-5 h-5 mr-2 text-blue-400" />
              Send us a message
            </h4>
            
            <div className="space-y-4">
              <div>
                <label className="block text-sm text-slate-400 mb-1.5">Your Name</label>
                <input 
                  type="text" 
                  className="w-full bg-slate-800/50 border border-slate-700 rounded-lg px-4 py-2.5 text-white focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500 text-sm"
                  placeholder="John Doe"
                />
              </div>
              
              <div>
                <label className="block text-sm text-slate-400 mb-1.5">Email Address</label>
                <input 
                  type="email" 
                  className="w-full bg-slate-800/50 border border-slate-700 rounded-lg px-4 py-2.5 text-white focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500 text-sm"
                  placeholder="your@email.com"
                />
              </div>
              
              <div>
                <label className="block text-sm text-slate-400 mb-1.5">Subject</label>
                <select className="w-full bg-slate-800/50 border border-slate-700 rounded-lg px-4 py-2.5 text-white focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500 text-sm">
                  <option>Select an option</option>
                  <option>Technical Support</option>
                  <option>Account Help</option>
                  <option>Feature Request</option>
                  <option>Billing Inquiry</option>
                  <option>Legal Request</option>
                  <option>Other</option>
                </select>
              </div>
              
              <div>
                <label className="block text-sm text-slate-400 mb-1.5">Message</label>
                <textarea 
                  rows={4}
                  className="w-full bg-slate-800/50 border border-slate-700 rounded-lg px-4 py-2.5 text-white focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500 text-sm"
                  placeholder="Describe your issue or question..."
                ></textarea>
              </div>
              
              <div className="flex items-center space-x-3">
                <input type="checkbox" id="priority-support" className="form-checkbox h-4 w-4 text-blue-500 bg-slate-800 border-slate-700 rounded focus:ring-blue-500" />
                <label htmlFor="priority-support" className="text-sm text-slate-400">
                  This is urgent (Priority support available for enterprise customers)
                </label>
              </div>
              
              <button className="w-full bg-gradient-to-r from-blue-600 to-indigo-600 hover:from-blue-700 hover:to-indigo-700 text-white py-2.5 px-4 rounded-lg font-medium transition-all duration-200 shadow-lg shadow-blue-900/30 flex items-center justify-center space-x-2">
                <Send className="w-4 h-4" />
                <span>Send Message</span>
              </button>
            </div>
          </div>
          
          {/* Contact Information */}
          <div className="space-y-5">
            <h4 className="text-white font-medium text-lg flex items-center">
              <Phone className="w-5 h-5 mr-2 text-blue-400" />
              Other ways to reach us
            </h4>
            
            <div className="space-y-4">
              <div className="bg-slate-800/50 p-4 rounded-lg border border-slate-700">
                <div className="flex items-start space-x-3">
                  <div className="flex-shrink-0 mt-0.5">
                    <Mail className="w-5 h-5 text-blue-400" />
                  </div>
                  <div>
                    <h5 className="text-white font-medium">Email Support</h5>
                    <p className="text-slate-400 text-sm">support@tracemaster.com</p>
                    <p className="text-blue-400 text-xs mt-1">Typically responds within 24 hours</p>
                  </div>
                </div>
              </div>
              
              <div className="bg-slate-800/50 p-4 rounded-lg border border-slate-700">
                <div className="flex items-start space-x-3">
                  <div className="flex-shrink-0 mt-0.5">
                    <MessageSquare className="w-5 h-5 text-green-400" />
                  </div>
                  <div>
                    <h5 className="text-white font-medium">Live Chat</h5>
                    <p className="text-slate-400 text-sm">Available 9AM-5PM EST</p>
                    <p className="text-green-400 text-xs mt-1">Look for the chat icon in the bottom right</p>
                  </div>
                </div>
              </div>
              
              <div className="bg-slate-800/50 p-4 rounded-lg border border-slate-700">
                <div className="flex items-start space-x-3">
                  <div className="flex-shrink-0 mt-0.5">
                    <Phone className="w-5 h-5 text-purple-400" />
                  </div>
                  <div>
                    <h5 className="text-white font-medium">Phone Support</h5>
                    <p className="text-slate-400 text-sm">+1 (555) 123-4567</p>
                    <p className="text-purple-400 text-xs mt-1">Enterprise customers only</p>
                  </div>
                </div>
              </div>
              
              <div className="bg-slate-800/50 p-4 rounded-lg border border-slate-700">
                <div className="flex items-start space-x-3">
                  <div className="flex-shrink-0 mt-0.5">
                    <MapPin className="w-5 h-5 text-yellow-400" />
                  </div>
                  <div>
                    <h5 className="text-white font-medium">Headquarters</h5>
                    <p className="text-slate-400 text-sm">123 Cyber Security Way</p>
                    <p className="text-slate-400 text-sm">Tech City, TC 10001</p>
                    <p className="text-yellow-400 text-xs mt-1">By appointment only</p>
                  </div>
                </div>
              </div>
              
              <div className="pt-2">
                <h5 className="text-white font-medium text-sm mb-2">Follow Us</h5>
                <div className="flex space-x-3">
                  <a href="#" className="text-slate-400 hover:text-blue-400 transition-colors">
                    <Twitter className="w-5 h-5" />
                  </a>
                  <a href="#" className="text-slate-400 hover:text-blue-600 transition-colors">
                    <Linkedin className="w-5 h-5" />
                  </a>
                  <a href="#" className="text-slate-400 hover:text-gray-300 transition-colors">
                    <Github className="w-5 h-5" />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      {/* Footer */}
      <div className="bg-slate-900/80 border-t border-slate-800 px-6 py-4 flex justify-between items-center">
        <div className="text-xs text-slate-500">
          <span className="flex items-center">
            <Clock className="w-3 h-3 mr-1.5" />
            Support Hours: Mon-Fri 9AM-5PM EST
          </span>
        </div>
        <button
           onClick={onClose}
          className="px-4 py-2 bg-slate-800 hover:bg-slate-700 text-slate-300 rounded-lg font-medium transition-colors duration-200"
        >
          Close
        </button>
      </div>
    </div>
  </div>

    </Modal>
  );

const Modal = ({ children, onClose }) => (
  <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/80 backdrop-blur-sm">
    <div className="relative bg-gradient-to-b from-slate-900 to-slate-950 border border-slate-800 rounded-xl max-w-4xl w-full mx-4 shadow-2xl overflow-hidden">
      <div className="bg-gradient-to-r from-blue-900/30 via-indigo-900/20 to-transparent border-b border-blue-900/30 p-5 flex justify-between items-center">
        <h3 className="text-xl font-bold text-white">{children}</h3>
        <button onClick={onClose} className="p-1.5 rounded-lg hover:bg-slate-800/50 transition-colors">
          <X className="w-5 h-5 text-slate-400" />
        </button>
      </div>
      <div className="p-6">
        {children}
      </div>
      <div className="bg-slate-900/80 border-t border-slate-800 px-6 py-4 flex justify-end">
        <button onClick={onClose} className="px-4 py-2 bg-gradient-to-r from-green-600 to-emerald-600 hover:from-green-700 hover:to-emerald-700 text-white rounded-lg">
          Close
        </button>
      </div>
    </div>
  </div>
);

export default Footer;